import objectAssign from 'object-assign';
import PropTypes from 'prop-types';
import React from 'react';
import request from 'superagent';
import $ from 'jquery';
import Modal from '../../shared/modal-new';

class WatchThisSearch extends React.Component {
  constructor(props){
    super(props);
    this.state = this.defaultState();
  }

  defaultState() {
    return {
      isOpen: false,
      freq: 'weekly',
      name:'',
      email:'',
      search: {},
      link: '#',
      validation:{},
      success: false,
    };
  }

  componentDidMount(){
    $(window).on('watchThisSearch.open', this.openModal);
    $(window).on('watchThisSearch.close', this.closeModal);
  }

  componentWillUnmount(){
    $(window).off('watchThisSearch.open', this.openModal);
    $(window).off('watchThisSearch.close', this.closeModal);
  }

  openModal = (e) => {
    this.lastFocus = document.activeElement;
    this.setState({
      isOpen:true,
      search: objectAssign({}, this.props.search, {source: 'sir'}),
      link: this.currentLink(),
    });
    e.stopPropagation();
  }

  currentLink = () => {
    if (typeof document !== 'undefined') {
      return document.location.href;
    }
    return '#';
  }

  onEmailChange = (event) => {
    this.setState({email: event.target.value});
  }

  onFrequencyChange = (event) => {
    this.setState({freq: event.target.value});
  }

  onNameChange = (event) => {
    this.setState({name: event.target.value});
  }

  closeModal = () => {
    this.setState(this.defaultState());
    if (this.lastFocus) {
      this.lastFocus.focus();
    }
  }

  save = (e) => {
    request
      .post('/api/watches/create')
      .set('Content-Type', 'application/json')
      .send({
        email: this.state.email,
        search: this.state.search,
        name: this.state.name,
        link: this.state.link,
        freq: this.state.freq
      })
      .end((error, response) => {
        if (!error) {
          this.setState({success:true});
        } else {
          alert('There was an error with your request. Please try again later!');
        }
      });
    e.preventDefault();
  }

  render() {
    const body = this.state.success ?
      (
        <div>
          You have successfully saved your search entitled <strong>{this.state.name}</strong>
        </div>
      ) : (
      <div>
        <form id="wts-form" onSubmit={this.save}>
          <p>
            Please enter a name for this search and an email address to which we can send the results. "*" indicates a required field
          </p>
          <br />
          <h2>Search Name*:</h2>
          <div>
            <input required type='text' ref="searchName" onChange={this.onNameChange} placeholder="Search Name"/>
          </div>
          <h2>Email*:</h2>
          <div>
            <input required autoComplete="email" type='email' onChange={this.onEmailChange} placeholder="Email Address"/>
          </div>
          <div className="controls-row">
            <fieldset>
              <legend>
                <h2>Frequency:</h2>
              </legend>
              <label className="radio-inline">
                  <input type="radio" name="frequency" onChange={this.onFrequencyChange} value="daily" checked={this.state.freq === "daily"} /> Daily
              </label>
              <label className="radio-inline">
                  <input type="radio" name="frequency" onChange={this.onFrequencyChange} value="weekly" checked={this.state.freq === "weekly"} /> Weekly
              </label>
            </fieldset>
          </div>
        </form>

      </div>
    );

    const submit = this.state.success ? null : (
      <div className="modal-footer">
        <button type="submit" form="wts-form" className="primary-button">Save</button>
      </div>
    );
    return (
      <span id="modal-watch">
        {this.state.isOpen && (
          <Modal onModalClose={this.closeModal}>
            <Modal.Header>
              <h1 id="watch-this-search" className="modal-title">Watch This Search</h1>
            </Modal.Header>
            <Modal.Body>
              {body}
            </Modal.Body>
            <Modal.Footer>
              <div className="notice">
                We respect your privacy and will not share your email address. For more information view our complete <a href="/privacy-policy.pdf" target="_blank">privacy policy</a>.
              </div>
              {submit}
            </Modal.Footer>
          </Modal>
        )}
      </span>
    );
  }
}

WatchThisSearch.propTypes = {
  search: PropTypes.object.isRequired
}

export default WatchThisSearch;


// WEBPACK FOOTER //
// ./src/components/search/watch-this-search/watch-this-search.jsx